import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';
import ListLayout from '../../Generic/ListLayout';
import DataTable from '../../Generic/DataTable';
import confirmDeleteDialog from '../../Generic/confirmDeleteDialog';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useDeleteItem from '../../../hooks/useDeleteItem';
import useFilterData from '../../../hooks/useFilterData';
import useFetchData from '../../../hooks/useFetchData';
import useLocalizedTextsMap from '../../../hooks/useLocalizedTextsMap';
import { useSetMenu } from "../../../hooks/useSetMenu";
import { createGeneralColumn,createActiveColumn, createActionColumn } from '../../Generic/dataGridColumns';
import AuthContext from "../../../context/AuthProvider";
const List = () => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useContext(AuthContext);
  const { mainStore, categoryStore } = useStore();
  const { t } = useTranslation();
  const localizedTextsMap = useLocalizedTextsMap();
  useSetMenu(mainStore.CategoryMenuType, mainStore.CategoryMenuNo);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  //FetchData and Search


  useFetchData(axiosPrivate, `/Categories`, categoryStore);
  const filteredData = useFilterData(toJS(categoryStore.category), searchQuery);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  //Delete
  const deleteCategory = useDeleteItem(axiosPrivate, '/Categories', categoryStore.deleteCategory);

  const remove = useCallback((id) => {
    confirmDeleteDialog(t, deleteCategory, id);
  }, [deleteCategory, t]);

  const cols = useMemo(() => [
    createGeneralColumn("name", "category", t),
    createGeneralColumn("panelName", "panel", t),
    createActiveColumn(t),
    createActionColumn(t,"/Category/Edit",remove),
    // eslint-disable-next-line
  ].filter(Boolean), [t, remove]);

  useEffect(() => {
    setColumns(cols);
    // eslint-disable-next-line
  }, [t]);

  return (
    <>
      <ListLayout
        title={t("categoryListTitle")}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("searchPlaceholder")}
        addButtonLink="/Category/Add"
        addButtonTitle={t("add")}
      >
        <DataTable
          rows={filteredData}
          columns={columns}
          pageSize={pageSize}
          setPageSize={setPageSize}
          localeTextsMap={localizedTextsMap}
        />
      </ListLayout>
    </>
  );
};

export default observer(List);